import React from 'react';
import styled from '@emotion/styled';
import { Input } from 'reactstrap';

const THEMECHANGE = styled(Input)`
  padding: 1.3rem 1rem;
`;

/**
 * @type { React.ForwardRefExoticComponent<import('reactstrap').InputProps & React.RefAttributes<import('reactstrap').InputProps>>}
 */

const InputField = React.forwardRef((props, ref) => {
  const { placeholder } = props;
  return <THEMECHANGE ref={ref} {...props} placeholder={placeholder} />;
});

InputField.displayName = 'Input Field';

export default InputField;
